"use client"

import * as React from "react"

export function useDebouncedValue<T>(value: T, delayMs = 300) {
  const [debounced, setDebounced] = React.useState<T>(value)

  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebounced(value)
    }, delayMs)

    return () => {
      window.clearTimeout(timer)
    }
  }, [value, delayMs])

  return debounced
}
